import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { DataGrid, Icon, IconButton, Stack, Tooltip, Typography } from '@emburse/embark-core';
import { EditIcon, ReceiptIcon } from '@emburse/embark-icons';
import { dayJsFormatDate } from '../../util/dateAdapter';
import { AuditAlertsContext } from './AuditAlertsProvider';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { getIconForViolationStatus } from './util';
export default function AlertsDataGrid() {
    useTranslation();
    const { auditExpenses, setSelectedAuditExpense, loading, error, toggleSidebar } = useContext(AuditAlertsContext);
    const localeText = {
        noRowsLabel: $t('There are no alerts to display')
    };
    return (_jsx(DataGrid, { rows: !loading && !error ? auditExpenses : [], columns: [
            {
                field: 'Status',
                headerName: $t('Status'),
                flex: 1.5,
                renderCell: (params) => {
                    const icon = getIconForViolationStatus(params.value);
                    return _jsx(Icon, { iconUrl: icon, "data-qa": "status-icon" });
                }
            },
            {
                field: 'Receipt',
                headerName: $t('Receipt'),
                flex: 1.7,
                renderCell: (params) => {
                    if (params.row.ReceiptData.ID === null) {
                        return null;
                    }
                    return (_jsx(Stack, { children: _jsx(IconButton, { className: "js-modal-open", "data-target": "rv_modal", "data-rid": params.row.ReceiptData.ID, "data-image-width": params.row.ReceiptData.Width || '', "data-image-height": params.row.ReceiptData.Height || '', "data-image-max-width": params.row.ReceiptData.ImageMaxWidth || '', "data-image-max-height": params.row.ReceiptData.ImageMaxHeight || '', "data-receipt-url": params.row.ReceiptData.ModalURL, "data-receipt-full-url": params.row.ReceiptData.FullURL, "data-sid": params.row.ReceiptData.SID, "data-file-name": params.row.ReceiptData.FileName, "data-file-type": params.row.ReceiptData.FileType, "data-language": "en", "data-qa": "receipt-icon", children: _jsx(Icon, { iconUrl: ReceiptIcon }) }) }));
                }
            },
            {
                field: 'Date',
                headerName: $t('Date'),
                flex: 3,
                renderCell: (params) => (_jsx(Tooltip, { title: dayJsFormatDate(params.value, 'MM/DD/YYYY'), children: _jsx(Typography, { noWrap: true, "data-qa": "date", children: dayJsFormatDate(params.value, 'MM/DD/YYYY') }) }))
            },
            {
                field: 'Employee',
                headerName: $t('Employee'),
                flex: 4.5,
                renderCell: (params) => (_jsx(Tooltip, { title: params.value, children: _jsx(Typography, { noWrap: true, "data-qa": "employee", children: params.value }) }))
            },
            {
                field: 'Category',
                headerName: $t('Category'),
                flex: 5.5,
                renderCell: (params) => (_jsx(Tooltip, { title: params.value, children: _jsx(Typography, { noWrap: true, "data-qa": "category", children: params.value }) }))
            },
            {
                field: 'Vendor',
                headerName: $t('Vendor'),
                flex: 4,
                renderCell: (params) => (_jsx(Tooltip, { title: params.value, children: _jsx(Typography, { noWrap: true, "data-qa": "vendor", children: params.value }) }))
            },
            {
                field: 'Reason',
                headerName: $t('Description'),
                flex: 7.55,
                renderCell: (params) => (_jsx(Tooltip, { title: params.value, children: _jsx(Typography, { noWrap: true, "data-qa": "description", children: params.value }) }))
            },
            {
                field: 'Amount',
                headerName: $t('Amount'),
                flex: 3.45,
                renderCell: (params) => (_jsx(Tooltip, { title: params.value, children: _jsxs(Typography, { noWrap: true, "data-qa": "amount", children: [params.value, " ", params.row.CurrencyCode] }) }))
            },
            {
                field: '',
                headerName: '',
                flex: 1,
                renderCell: (params) => (_jsx(Stack, { sx: { justifyContent: 'center' }, children: _jsx(IconButton, { onClick: (event) => {
                            event.stopPropagation();
                            setSelectedAuditExpense(params.row);
                            toggleSidebar();
                        }, "data-qa": "edit-button", children: _jsx(Icon, { iconUrl: EditIcon }) }) }))
            }
        ], localeText: localeText, sx: { width: '100%' }, pageSizeOptions: [25, 50, 100], initialState: { pagination: { paginationModel: { pageSize: 50 } } }, autoHeight: true, "data-qa": "alerts-data-grid" }));
}
